import React from "react";
import { Colors } from "helpers/colors";

interface AppointmentIconProps {
  readonly isActive: boolean;
}

export const AppointmentIcon: React.FC<AppointmentIconProps> = ({
  isActive
}) => {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <filter
          x="-28.4%"
          y="-28.4%"
          width="156.8%"
          height="156.8%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feMorphology
            radius="0.5"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="2"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="2"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g
        id="Asset-Artboard-Page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="appointment-icon-button">
          <g id="Rectangle_203-6-Copy-3" filter="url(#filter-1)">
            <rect
              id="Rectangle"
              stroke={isActive ? Colors.DodgerBlue : "#B5D264"}
              fill={isActive ? Colors.AliceBlue : "#EFF4DF"}
              x="0.5"
              y="0.5"
              width="43"
              height="43"
              rx="9.5"
            ></rect>
            <path
              d="M27.5424281,21.6160638 L21.8281355,27.3303563 C21.6830461,27.4642851 21.4598315,27.4642851 21.3147421,27.3303563 L18.1004525,24.1160668 C17.9665238,23.9709773 17.9665238,23.7477628 18.1004525,23.6138341 L18.613846,23.1004406 C18.7477747,22.9665119 18.9709893,22.9665119 19.1160787,23.1004406 L21.5714388,25.5558007 L26.5268018,20.6004376 C26.6718913,20.4665089 26.8951058,20.4665089 27.0290346,20.6004376 L27.5424281,21.1138311 C27.6763568,21.2477598 27.6763568,21.4709744 27.5424281,21.6160638 Z M14.4285731,29.4285731 L30.1428776,29.4285731 L30.1428776,17.9999881 L14.4285731,17.9999881 L14.4285731,29.4285731 Z M18.7142925,15.8571284 L18.7142925,12.6428388 C18.7142925,12.4419457 18.5580423,12.2856956 18.3571492,12.2856956 L17.6428627,12.2856956 C17.4419696,12.2856956 17.2857194,12.4419457 17.2857194,12.6428388 L17.2857194,15.8571284 C17.2857194,16.0580215 17.4419696,16.2142717 17.6428627,16.2142717 L18.3571492,16.2142717 C18.5580423,16.2142717 18.7142925,16.0580215 18.7142925,15.8571284 Z M27.2857313,15.8571284 L27.2857313,12.6428388 C27.2857313,12.4419457 27.1294811,12.2856956 26.928588,12.2856956 L26.2143015,12.2856956 C26.0134084,12.2856956 25.8571582,12.4419457 25.8571582,12.6428388 L25.8571582,15.8571284 C25.8571582,16.0580215 26.0134084,16.2142717 26.2143015,16.2142717 L26.928588,16.2142717 C27.1294811,16.2142717 27.2857313,16.0580215 27.2857313,15.8571284 Z M31.5714507,15.1428418 L31.5714507,29.4285731 C31.5714507,30.2098241 30.9241285,30.8571463 30.1428776,30.8571463 L14.4285731,30.8571463 C13.6473222,30.8571463 13,30.2098241 13,29.4285731 L13,15.1428418 C13,14.3615909 13.6473222,13.7142687 14.4285731,13.7142687 L15.8571463,13.7142687 L15.8571463,12.6428388 C15.8571463,11.6606948 16.6607186,10.8571224 17.6428627,10.8571224 L18.3571492,10.8571224 C19.3392933,10.8571224 20.1428657,11.6606948 20.1428657,12.6428388 L20.1428657,13.7142687 L24.4285851,13.7142687 L24.4285851,12.6428388 C24.4285851,11.6606948 25.2321574,10.8571224 26.2143015,10.8571224 L26.928588,10.8571224 C27.9107321,10.8571224 28.7143044,11.6606948 28.7143044,12.6428388 L28.7143044,13.7142687 L30.1428776,13.7142687 C30.9241285,13.7142687 31.5714507,14.3615909 31.5714507,15.1428418 Z"
              id=""
              stroke="#212B40"
              strokeWidth="0.4"
              fill="#212B40"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
